// // import React, { useState, useEffect, useRef } from "react";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import { motion, AnimatePresence } from "framer-motion";
// // import {
// //     FiSearch,
// //     FiX,
// //     FiFilter,
// //     FiStar,
// //     FiShoppingCart,
// //     FiHeart,
// //     FiPlus,
// //     FiMinus,
// //     FiChevronUp,
// //     FiChevronDown
// // } from "react-icons/fi";
// // import { useCart } from "../App";
// // const [categoryMap, setCategoryMap] = useState({});
// // // const PRODUCTS_API = "https://server.havbit.in/api/products";
// // const PRODUCTS_API = "https://server.havbit.in/api/public/products";


// // // ✅ Helper: create URL-friendly slug from product name
// // const createSlug = (name) => {
// //     if (!name) return '';
// //     return name
// //         .toLowerCase()
// //         .trim()
// //         .replace(/[^a-z0-9\s-]/g, '')
// //         .replace(/\s+/g, '-')
// //         .replace(/-+/g, '-')
// //         .replace(/(^-|-$)/g, '');
// // };

// // // ✅ Helper: remove timestamp suffix from API slug
// // const cleanApiSlug = (slug) => {
// //     if (!slug) return '';
// //     return slug.replace(/-\d{10,}$/, '');
// // };

// // // ✅ Helper: get best slug for a product
// // const getProductSlug = (product) => {
// //     if (product.slug) return cleanApiSlug(product.slug);
// //     return createSlug(product.name);
// // };

// // export default function SearchPage() {
// //     const navigate = useNavigate();
// //     const location = useLocation();
// //     const { cart, addToCart, updateQty, removeFromCart } = useCart();

// //     const searchParams = new URLSearchParams(location.search);
// //     const initialQuery = searchParams.get('q') || '';

// //     const [searchQuery, setSearchQuery] = useState(initialQuery);
// //     const [products, setProducts] = useState([]);
// //     const [filteredProducts, setFilteredProducts] = useState([]);
// //     const [loading, setLoading] = useState(false);
// //     const [wishlist, setWishlist] = useState({});
// //     const [sortBy, setSortBy] = useState("relevance");
// //     const [priceRange, setPriceRange] = useState([0, 5000]);
// //     const [categoryFilter, setCategoryFilter] = useState("all");
// //     const [categories, setCategories] = useState([]);
// //     const [showMobileFilters, setShowMobileFilters] = useState(false);
// //     const [showSortOptions, setShowSortOptions] = useState(false);

// //     const searchInputRef = useRef(null);

// //     const cartQuantities = cart.reduce((acc, item) => {
// //         acc[item._id] = item.qty || 1;
// //         return acc;
// //     }, {});

// //     useEffect(() => {
// //         fetchProducts();
// //     }, []);

 

// //     useEffect(() => {
// //         if (searchQuery) {
// //             performSearch();
// //         }
// //     }, [searchQuery, products, sortBy, priceRange, categoryFilter]);

// //     const fetchProducts = async () => {
// //         try {
// //             setLoading(true);
// //             const response = await fetch(PRODUCTS_API);
// //             if (!response.ok) throw new Error("Failed to fetch products");

// //             const data = await response.json();
// //             // const productsArray = data.products || data || [];
// //             // const productsArray = data.data || data.products || [];


// //             const productsArray = data.products || data.data || data || [];

// //             const uniqueCategories = [...new Set(productsArray
// //                 .map(p => p.category?.name || p.category || "Uncategorized")
// //                 .filter(Boolean)
// //             )];
// //             setCategories(uniqueCategories);

// //             const formattedProducts = productsArray.map(product => ({
// //                 ...product,
// //                 id: product._id || product.id,
// //                 // ✅ store slug for navigation
// //                 slug: getProductSlug(product),
// //                 name: product.name || "Product",
// //                 price: product.newPrice || product.price || 0,
// //                 originalPrice: product.oldPrice || product.price * 1.2,
// //                 image: product.image || "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400",
// //                 category: product.category?.name || product.category || "Uncategorized",
// //                 rating: parseFloat((Math.random() * 1.5 + 3.5).toFixed(1)),
// //                 reviewCount: Math.floor(Math.random() * 1000) + 50,
// //                 stock: product.stock || Math.floor(Math.random() * 50) + 10,
// //                 weight: ["100g", "200g", "500g", "1kg"][Math.floor(Math.random() * 4)],
// //                 deliveryTime: `${Math.floor(Math.random() * 20) + 10} mins`,
// //                 discount: Math.floor(Math.random() * 40) + 5
// //             }));

// //             setProducts(formattedProducts);
// //             setLoading(false);
// //         } catch (error) {
// //             console.error("Error fetching products:", error);
// //             setLoading(false);
// //         }
// //     };

// //     const performSearch = () => {
// //         let results = products.filter(product => {
// //             const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
// //                 product.category.toLowerCase().includes(searchQuery.toLowerCase());
// //             const matchesPrice = product.price >= priceRange[0] && product.price <= priceRange[1];
// //             const matchesCategory = categoryFilter === "all" ||
// //                 product.category.toLowerCase() === categoryFilter.toLowerCase();
// //             return matchesSearch && matchesPrice && matchesCategory;
// //         });

// //         results.sort((a, b) => {
// //             switch (sortBy) {
// //                 case "price-low": return a.price - b.price;
// //                 case "price-high": return b.price - a.price;
// //                 case "rating": return b.rating - a.rating;
// //                 case "discount": return b.discount - a.discount;
// //                 default:
// //                     const aScore = a.name.toLowerCase().includes(searchQuery.toLowerCase()) ? 2 : 1;
// //                     const bScore = b.name.toLowerCase().includes(searchQuery.toLowerCase()) ? 2 : 1;
// //                     return bScore - aScore;
// //             }
// //         });

// //         setFilteredProducts(results);
// //     };

// //     const handleSearch = (e) => {
// //         e.preventDefault();
// //         if (searchQuery.trim()) {
// //             navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
// //             performSearch();
// //         }
// //     };

// //     const clearSearch = () => {
// //         setSearchQuery("");
// //         setFilteredProducts([]);
// //         navigate("/search");
// //     };

// //     const handleAddToCart = (product, quantity = 1) => {
// //         const cartItem = {
// //             _id: product.id,
// //             name: product.name,
// //             price: product.price,
// //             originalPrice: product.originalPrice,
// //             image: product.image,
// //             category: product.category,
// //             weight: product.weight,
// //             qty: quantity
// //         };
// //         addToCart(cartItem, quantity);
// //     };

// //     const handleQuantityUpdate = (productId, change) => {
// //         const currentQty = cartQuantities[productId] || 0;
// //         const newQty = currentQty + change;
// //         if (newQty < 1) {
// //             removeFromCart(productId);
// //         } else {
// //             updateQty(productId, newQty);
// //         }
// //     };

// //     const toggleWishlist = (productId) => {
// //         setWishlist(prev => ({ ...prev, [productId]: !prev[productId] }));
// //     };

// //     const resetFilters = () => {
// //         setSortBy("relevance");
// //         setPriceRange([0, 5000]);
// //         setCategoryFilter("all");
// //     };

// //     return (
// //         <div className="min-h-screen bg-gray-50 pb-24">

// //             {/* Mobile search header */}
// //             <div className="lg:hidden bg-white sticky top-0 z-30 border-b shadow-sm">
// //                 <div className="container mx-auto px-4 py-3">
// //                     <form onSubmit={handleSearch} className="relative">
// //                         <div className="flex items-center gap-2">
// //                             <button
// //                                 type="button"
// //                                 onClick={() => navigate(-1)}
// //                                 className="text-gray-600 hover:text-red-600 flex-shrink-0"
// //                             >
// //                                 ←
// //                             </button>
// //                             <div className="flex-1 relative">
// //                                 <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
// //                                 <input
// //                                     ref={searchInputRef}
// //                                     type="text"
// //                                     value={searchQuery}
// //                                     onChange={(e) => setSearchQuery(e.target.value)}
// //                                     placeholder="Search for products, brands, categories..."
// //                                     className="w-full pl-12 pr-12 py-3 bg-gray-100 border-none rounded-xl focus:ring-2 focus:ring-red-500 focus:bg-white"
// //                                 />
// //                                 {searchQuery && (
// //                                     <button
// //                                         type="button"
// //                                         onClick={clearSearch}
// //                                         className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
// //                                     >
// //                                         <FiX size={20} />
// //                                     </button>
// //                                 )}
// //                             </div>
// //                         </div>
// //                     </form>
// //                 </div>
// //             </div>

// //             <div className="container mx-auto px-4 py-4">
// //                 {/* Mobile Filters & Sort Bar */}
// //                 <div className="lg:hidden flex items-center justify-between mb-4 bg-white rounded-xl shadow-sm p-3">
// //                     <div className="flex items-center gap-2">
// //                         <button
// //                             onClick={() => setShowMobileFilters(!showMobileFilters)}
// //                             className="flex items-center gap-2 text-gray-700 text-sm font-medium"
// //                         >
// //                             <FiFilter />
// //                             Filters
// //                             {showMobileFilters ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
// //                         </button>
// //                         {filteredProducts.length > 0 && (
// //                             <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded-full">
// //                                 {filteredProducts.length}
// //                             </span>
// //                         )}
// //                     </div>

// //                     <div className="relative">
// //                         <button
// //                             onClick={() => setShowSortOptions(!showSortOptions)}
// //                             className="flex items-center gap-2 text-gray-700 text-sm font-medium"
// //                         >
// //                             Sort
// //                             {showSortOptions ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
// //                         </button>

// //                         <AnimatePresence>
// //                             {showSortOptions && (
// //                                 <motion.div
// //                                     initial={{ opacity: 0, y: -10 }}
// //                                     animate={{ opacity: 1, y: 0 }}
// //                                     exit={{ opacity: 0, y: -10 }}
// //                                     className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-lg border py-2 z-50 min-w-48"
// //                                 >
// //                                     {[
// //                                         { value: "relevance", label: "Relevance" },
// //                                         { value: "price-low", label: "Price: Low to High" },
// //                                         { value: "price-high", label: "Price: High to Low" },
// //                                         { value: "rating", label: "Customer Rating" },
// //                                         { value: "discount", label: "Discount %" }
// //                                     ].map((option) => (
// //                                         <button
// //                                             key={option.value}
// //                                             onClick={() => {
// //                                                 setSortBy(option.value);
// //                                                 setShowSortOptions(false);
// //                                             }}
// //                                             className={`w-full px-4 py-2 text-left text-sm ${sortBy === option.value
// //                                                 ? "bg-red-50 text-red-700 font-medium"
// //                                                 : "text-gray-700 hover:bg-gray-100"
// //                                                 }`}
// //                                         >
// //                                             {option.label}
// //                                         </button>
// //                                     ))}
// //                                 </motion.div>
// //                             )}
// //                         </AnimatePresence>
// //                     </div>
// //                 </div>

// //                 <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
// //                     {/* Filters Sidebar */}
// //                     {(showMobileFilters || window.innerWidth >= 1024) && (
// //                         <div className="lg:col-span-1">
// //                             <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:sticky lg:top-24">
// //                                 <div className="flex items-center justify-between mb-6">
// //                                     <h3 className="font-bold text-gray-900 flex items-center gap-2">
// //                                         <FiFilter />
// //                                         Filters
// //                                     </h3>
// //                                     <button onClick={resetFilters} className="text-sm text-red-600 hover:text-red-700 font-medium">
// //                                         Reset All
// //                                     </button>
// //                                 </div>

// //                                 <div className="mb-6">
// //                                     <h4 className="font-medium text-gray-900 mb-3">Price Range</h4>
// //                                     <div className="space-y-2">
// //                                         <div className="flex items-center justify-between">
// //                                             <span className="text-sm text-gray-600">Min: ₹{priceRange[0]}</span>
// //                                             <span className="text-sm text-gray-600">Max: ₹{priceRange[1]}</span>
// //                                         </div>
// //                                         <input
// //                                             type="range" min="0" max="5000" step="100"
// //                                             value={priceRange[1]}
// //                                             onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value)])}
// //                                             className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-red-600"
// //                                         />
// //                                         <div className="flex justify-between text-xs text-gray-500">
// //                                             <span>₹0</span><span>₹2500</span><span>₹5000</span>
// //                                         </div>
// //                                     </div>
// //                                 </div>

// //                                 <div className="mb-6">
// //                                     <h4 className="font-medium text-gray-900 mb-3">Categories</h4>
// //                                     <div className="space-y-2 max-h-60 overflow-y-auto">
// //                                         <label className="flex items-center gap-2 cursor-pointer">
// //                                             <input type="radio" name="category" value="all"
// //                                                 checked={categoryFilter === "all"}
// //                                                 onChange={(e) => setCategoryFilter(e.target.value)}
// //                                                 className="w-4 h-4 text-red-600" />
// //                                             <span className="text-sm text-gray-700">All Categories</span>
// //                                         </label>
// //                                         {categories.map((category) => (
// //                                             <label key={category} className="flex items-center gap-2 cursor-pointer">
// //                                                 <input type="radio" name="category" value={category}
// //                                                     checked={categoryFilter === category}
// //                                                     onChange={(e) => setCategoryFilter(e.target.value)}
// //                                                     className="w-4 h-4 text-red-600" />
// //                                                 <span className="text-sm text-gray-700">{category}</span>
// //                                             </label>
// //                                         ))}
// //                                     </div>
// //                                 </div>

// //                                 <div>
// //                                     <h4 className="font-medium text-gray-900 mb-3">Sort By</h4>
// //                                     <div className="space-y-2">
// //                                         {[
// //                                             { value: "relevance", label: "Relevance" },
// //                                             { value: "price-low", label: "Price: Low to High" },
// //                                             { value: "price-high", label: "Price: High to Low" },
// //                                             { value: "rating", label: "Customer Rating" },
// //                                             { value: "discount", label: "Discount %" }
// //                                         ].map((option) => (
// //                                             <label key={option.value} className="flex items-center gap-2 cursor-pointer">
// //                                                 <input type="radio" name="sort" value={option.value}
// //                                                     checked={sortBy === option.value}
// //                                                     onChange={(e) => setSortBy(e.target.value)}
// //                                                     className="w-4 h-4 text-red-600" />
// //                                                 <span className="text-sm text-gray-700">{option.label}</span>
// //                                             </label>
// //                                         ))}
// //                                     </div>
// //                                 </div>

// //                                 <div className="lg:hidden mt-6">
// //                                     <button onClick={() => setShowMobileFilters(false)}
// //                                         className="w-full py-3 bg-red-600 text-white font-medium rounded-lg">
// //                                         Apply Filters
// //                                     </button>
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     )}

// //                     {/* Search Results */}
// //                     <div className="lg:col-span-3">
// //                         <div className="flex items-center justify-between mb-6">
// //                             <div>
// //                                 <h2 className="text-lg font-bold text-gray-900">
// //                                     {searchQuery ? `Search results for "${searchQuery}"` : "Search for products"}
// //                                 </h2>
// //                                 <p className="text-sm text-gray-600">
// //                                     {searchQuery ? `${filteredProducts.length} products found` : "Type to search"}
// //                                 </p>
// //                             </div>
// //                             {searchQuery && (
// //                                 <div className="text-sm text-gray-600 hidden lg:block">
// //                                     Showing {filteredProducts.length} of {products.length} products
// //                                 </div>
// //                             )}
// //                         </div>

// //                         {loading && (
// //                             <div className="flex flex-col items-center justify-center h-64">
// //                                 <div className="w-12 h-12 border-4 border-red-200 border-t-red-600 rounded-full animate-spin mb-4"></div>
// //                                 <p className="text-gray-600">Searching products...</p>
// //                             </div>
// //                         )}

// //                         {!loading && searchQuery && filteredProducts.length === 0 && (
// //                             <div className="text-center py-12 bg-white rounded-2xl">
// //                                 <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
// //                                     <FiSearch className="text-gray-400 text-2xl" />
// //                                 </div>
// //                                 <h3 className="text-lg font-bold text-gray-900 mb-2">No results found</h3>
// //                                 <p className="text-gray-600 mb-6">We couldn't find any products matching "{searchQuery}"</p>
// //                                 <div className="flex flex-col sm:flex-row gap-3 justify-center">
// //                                     <button onClick={clearSearch}
// //                                         className="px-6 py-2 border-2 border-red-600 text-red-600 rounded-full font-medium">
// //                                         Clear Search
// //                                     </button>
// //                                     <button onClick={() => navigate("/products")}
// //                                         className="px-6 py-2 bg-red-600 text-white rounded-full font-medium">
// //                                         Browse All Products
// //                                     </button>
// //                                 </div>
// //                             </div>
// //                         )}

// //                         {!loading && filteredProducts.length > 0 && (
// //                             <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
// //                                 <AnimatePresence>
// //                                     {filteredProducts.map((product) => (
// //                                         <ProductCard
// //                                             key={product.id}
// //                                             product={product}
// //                                             onAddToCart={handleAddToCart}
// //                                             onToggleWishlist={toggleWishlist}
// //                                             onQuantityUpdate={handleQuantityUpdate}
// //                                             isWishlisted={wishlist[product.id]}
// //                                             cartQuantity={cartQuantities[product.id] || 0}
// //                                         />
// //                                     ))}
// //                                 </AnimatePresence>
// //                             </div>
// //                         )}

// //                         {!searchQuery && !loading && (
// //                             <div className="bg-white rounded-2xl p-6">
// //                                 <h3 className="font-bold text-gray-900 mb-4">Popular Searches</h3>
// //                                 <div className="flex flex-wrap gap-2">
// //                                     {["Protein Powder", "Vitamins", "Ayurvedic", "Weight Loss", "Energy Drinks", "Hair Care", "Skin Care"].map((term) => (
// //                                         <button key={term}
// //                                             onClick={() => { setSearchQuery(term); navigate(`/search?q=${encodeURIComponent(term)}`); }}
// //                                             className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full text-sm font-medium">
// //                                             {term}
// //                                         </button>
// //                                     ))}
// //                                 </div>
// //                             </div>
// //                         )}
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // }

// // const ProductCard = ({ product, onAddToCart, onToggleWishlist, onQuantityUpdate, isWishlisted, cartQuantity = 0 }) => {
// //     const navigate = useNavigate(); // ✅ added for slug navigation

// //     const handleAddClick = () => onAddToCart(product, 1);
// //     const handleIncrement = () => onQuantityUpdate(product.id, 1);
// //     const handleDecrement = () => onQuantityUpdate(product.id, -1);

// //     // ✅ navigate using slug instead of ID
// //     const handleProductClick = () => {
// //         navigate(`/product/${product.slug || createSlug(product.name)}`);
// //     };

// //     return (
// //         <motion.div whileHover={{ y: -2 }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
// //             <div className="relative cursor-pointer" onClick={handleProductClick}>
// //                 <div className="h-40 bg-gray-50">
// //                     <img src={product.image} alt={product.name}
// //                         className="w-full h-full object-contain p-4"
// //                         onError={(e) => { e.target.src = "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400"; }} />
// //                 </div>

// //                 {product.discount > 0 && (
// //                     <div className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded">
// //                         {product.discount}% OFF
// //                     </div>
// //                 )}

// //                 <button
// //                     onClick={(e) => { e.stopPropagation(); onToggleWishlist(product.id); }}
// //                     className="absolute top-2 right-2 w-7 h-7 bg-white rounded-full flex items-center justify-center shadow-md"
// //                 >
// //                     {isWishlisted ? <FiHeart className="text-red-500 fill-current" size={16} /> : <FiHeart className="text-gray-400" size={16} />}
// //                 </button>

// //                 {product.stock < 10 && product.stock > 0 && (
// //                     <div className="absolute bottom-2 left-2 bg-amber-500 text-white text-xs px-2 py-1 rounded">
// //                         Only {product.stock} left
// //                     </div>
// //                 )}
// //             </div>

// //             <div className="p-3">
// //                 {/* ✅ Product name bhi clickable */}
// //                 <h4
// //                     className="text-sm font-medium text-gray-900 mb-1 line-clamp-2 cursor-pointer hover:text-red-600 transition-colors"
// //                     onClick={handleProductClick}
// //                 >
// //                     {product.name}
// //                 </h4>
// //                 <p className="text-xs text-gray-500 mb-2">{product.weight}</p>

// //                 <div className="flex items-baseline gap-2 mb-2">
// //                     <span className="text-lg font-bold text-gray-900">₹{product.price}</span>
// //                     {product.originalPrice > product.price && (
// //                         <span className="text-sm text-gray-500 line-through">₹{Math.round(product.originalPrice)}</span>
// //                     )}
// //                 </div>

// //                 <div className="flex items-center gap-2 mb-3">
// //                     <div className="flex items-center">
// //                         <FiStar className="text-amber-400 fill-current" size={12} />
// //                         <span className="text-xs font-medium ml-1">{product.rating}</span>
// //                     </div>
// //                     <span className="text-xs text-gray-500">({product.reviewCount.toLocaleString()})</span>
// //                 </div>

// //                 {cartQuantity > 0 ? (
// //                     <div className="flex items-center justify-between bg-red-50 rounded-lg p-1">
// //                         <button onClick={handleDecrement} className="w-8 h-8 flex items-center justify-center rounded hover:bg-red-100 text-red-700">
// //                             <FiMinus size={16} />
// //                         </button>
// //                         <span className="font-medium text-red-700">{cartQuantity}</span>
// //                         <button onClick={handleIncrement} className="w-8 h-8 flex items-center justify-center rounded hover:bg-red-100 text-red-700">
// //                             <FiPlus size={16} />
// //                         </button>
// //                     </div>
// //                 ) : (
// //                     <button onClick={handleAddClick} disabled={product.stock === 0}
// //                         className={`w-full py-2 rounded-lg font-medium text-sm flex items-center justify-center gap-2 ${product.stock === 0 ? "bg-gray-200 text-gray-500 cursor-not-allowed" : "bg-red-100 text-red-700 hover:bg-red-200"}`}>
// //                         <FiShoppingCart size={16} />
// //                         {product.stock === 0 ? "Out of Stock" : "Add to Cart"}
// //                     </button>
// //                 )}

// //                 {product.stock > 0 && (
// //                     <div className="mt-3 flex items-center justify-center gap-1 text-xs text-red-600 font-medium">
// //                         <span>Free delivery • {product.deliveryTime}</span>
// //                     </div>
// //                 )}
// //             </div>
// //         </motion.div>
// //     );
// // };
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//     FiSearch,
//     FiX,
//     FiFilter,
//     FiChevronUp,
//     FiChevronDown
// } from "react-icons/fi";
// import { useCart } from "../App";
// import ProductCard from "./ProductCard";

// const PRODUCTS_API    = "https://server.havbit.in/api/public/products";
// const CATEGORIES_API  = "https://server.havbit.in/api/categories"; // ✅ Same as Products.jsx

// // ✅ Helper: create URL-friendly slug from product name
// const createSlug = (name) => {
//     if (!name) return '';
//     return name
//         .toLowerCase()
//         .trim()
//         .replace(/[^a-z0-9\s-]/g, '')
//         .replace(/\s+/g, '-')
//         .replace(/-+/g, '-')
//         .replace(/(^-|-$)/g, '');
// };

// const cleanApiSlug = (slug) => {
//     if (!slug) return '';
//     return slug.replace(/-\d{10,}$/, '');
// };

// const getProductSlug = (product) => {
//     if (product.slug) return cleanApiSlug(product.slug);
//     return createSlug(product.name);
// };

// export default function SearchPage() {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const { cart, addToCart, updateQty, removeFromCart } = useCart();

//     const searchParams = new URLSearchParams(location.search);
//     const initialQuery = searchParams.get('q') || '';

//     const [searchQuery, setSearchQuery]         = useState(initialQuery);
//     const [products, setProducts]               = useState([]);
//     const [filteredProducts, setFilteredProducts] = useState([]);
//     const [loading, setLoading]                 = useState(false);
//     const [wishlist, setWishlist]               = useState({});
//     const [sortBy, setSortBy]                   = useState("relevance");
//     const [priceRange, setPriceRange]           = useState([0, 5000]);
//     const [categoryFilter, setCategoryFilter]   = useState("all");
//     const [categories, setCategories]           = useState([]); // ✅ stores category NAMES
//     const [showMobileFilters, setShowMobileFilters] = useState(false);
//     const [showSortOptions, setShowSortOptions] = useState(false);

//     const searchInputRef = useRef(null);

//     const cartQuantities = cart.reduce((acc, item) => {
//         acc[item._id] = item.qty || 1;
//         return acc;
//     }, {});

//     useEffect(() => { fetchProducts(); }, []);

//     useEffect(() => {
//         if (searchQuery) performSearch();
//     }, [searchQuery, products, sortBy, priceRange, categoryFilter]);

//     const fetchProducts = async () => {
//         try {
//             setLoading(true);

//             // ✅ FIX: Fetch products AND categories simultaneously — same as Products.jsx
//             const [productsRes, categoriesRes] = await Promise.all([
//                 fetch(PRODUCTS_API),
//                 fetch(CATEGORIES_API)
//             ]);

//             if (!productsRes.ok) throw new Error("Failed to fetch products");

//             const productsResult  = await productsRes.json();
//             const categoriesData  = categoriesRes.ok ? await categoriesRes.json() : [];

//             // ✅ FIX: Build ID → Name map from categories API (same as Products.jsx)
//             const categoriesMap = {};
//             categoriesData.forEach(cat => {
//                 if (cat._id && cat.name) categoriesMap[cat._id] = cat.name;
//             });

//             // ✅ Handle both data.data and data.products response shapes
//             const productsArray = productsResult.data || productsResult.products || productsResult || [];

//             // ✅ FIX: Resolve category name using the map (same logic as Products.jsx)
//             const formattedProducts = productsArray.map(product => {
//                 let categoryName = "";

//                 if (product.category && categoriesMap[product.category]) {
//                     // category is an ID string → look up name in map
//                     categoryName = categoriesMap[product.category];
//                 } else if (product.category && typeof product.category === 'object' && product.category.name) {
//                     // category is already an object with name
//                     categoryName = product.category.name;
//                 } else if (typeof product.category === 'string' && product.category.length < 40) {
//                     // category is already a readable name (not a mongo ID)
//                     categoryName = product.category;
//                 } else if (product.categoryName) {
//                     categoryName = product.categoryName;
//                 }

//                 return {
//                     ...product,
//                     id: product._id || product.id,
//                     slug: getProductSlug(product),
//                     name: product.name || "Product",
//                     price: product.price || product.newPrice || 0,
//                     originalPrice: product.oldPrice || (product.price * 1.2) || 0,
//                     image: product.image || "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400",
//                     // ✅ category is now always a clean NAME string
//                     category: categoryName || "General",
//                     rating: parseFloat((Math.random() * 1.5 + 3.5).toFixed(1)),
//                     reviewCount: Math.floor(Math.random() * 1000) + 50,
//                     stock: product.stock || Math.floor(Math.random() * 50) + 10,
//                     weight: product.itemWeight || product.customWeight || product.size || product.weight || "100g",
//                     deliveryTime: `${Math.floor(Math.random() * 20) + 10} mins`,
//                     discount: product.discount || Math.floor(Math.random() * 40) + 5
//                 };
//             });

//             // ✅ Extract unique category names from formatted products
//             const uniqueCategories = [...new Set(
//                 formattedProducts
//                     .map(p => p.category)
//                     .filter(c => c && c !== "General")
//             )].sort();

//             setCategories(uniqueCategories);
//             setProducts(formattedProducts);
//             setLoading(false);
//         } catch (error) {
//             console.error("Error fetching products:", error);
//             setLoading(false);
//         }
//     };

//     const performSearch = () => {
//         let results = products.filter(product => {
//             // ✅ Sirf product name se exact match karo
//             const matchesSearch =
//                 product.name.toLowerCase().includes(searchQuery.toLowerCase());
//             const matchesPrice =
//                 product.price >= priceRange[0] && product.price <= priceRange[1];
//             const matchesCategory =
//                 categoryFilter === "all" ||
//                 product.category.toLowerCase() === categoryFilter.toLowerCase();

//             return matchesSearch && matchesPrice && matchesCategory;
//         });

//         results.sort((a, b) => {
//             switch (sortBy) {
//                 case "price-low":  return a.price - b.price;
//                 case "price-high": return b.price - a.price;
//                 case "rating":     return b.rating - a.rating;
//                 case "discount":   return b.discount - a.discount;
//                 default:
//                     const aScore = a.name.toLowerCase().includes(searchQuery.toLowerCase()) ? 2 : 1;
//                     const bScore = b.name.toLowerCase().includes(searchQuery.toLowerCase()) ? 2 : 1;
//                     return bScore - aScore;
//             }
//         });

//         setFilteredProducts(results);
//     };

//     const handleSearch = (e) => {
//         e.preventDefault();
//         if (searchQuery.trim()) {
//             navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
//             performSearch();
//         }
//     };

//     const clearSearch = () => {
//         setSearchQuery("");
//         setFilteredProducts([]);
//         navigate("/search");
//     };

//     const handleAddToCart = (product, quantity = 1) => {
//         addToCart({
//             _id: product.id,
//             name: product.name,
//             price: product.price,
//             originalPrice: product.originalPrice,
//             image: product.image,
//             category: product.category,
//             weight: product.weight,
//             qty: quantity
//         }, quantity);
//     };

//     const handleQuantityUpdate = (productId, change) => {
//         const currentQty = cartQuantities[productId] || 0;
//         const newQty = currentQty + change;
//         if (newQty < 1) removeFromCart(productId);
//         else updateQty(productId, newQty);
//     };

//     const toggleWishlist = (product) => {
//         const productId = product._id || product.id;
//         setWishlist(prev => ({ ...prev, [productId]: !prev[productId] }));
//     };

//     const resetFilters = () => {
//         setSortBy("relevance");
//         setPriceRange([0, 5000]);
//         setCategoryFilter("all");
//     };

//     return (
//         <div className="min-h-screen bg-gray-50 pb-24">

//             {/* Mobile search header */}
//             <div className="lg:hidden bg-white sticky top-0 z-30 border-b shadow-sm">
//                 <div className="container mx-auto px-4 py-3">
//                     <form onSubmit={handleSearch} className="relative">
//                         <div className="flex items-center gap-2">
//                             <button type="button" onClick={() => navigate(-1)} className="text-gray-600 hover:text-red-600 flex-shrink-0">←</button>
//                             <div className="flex-1 relative">
//                                 <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
//                                 <input
//                                     ref={searchInputRef}
//                                     type="text"
//                                     value={searchQuery}
//                                     onChange={(e) => setSearchQuery(e.target.value)}
//                                     placeholder="Search for products, brands, categories..."
//                                     className="w-full pl-12 pr-12 py-3 bg-gray-100 border-none rounded-xl focus:ring-2 focus:ring-red-500 focus:bg-white"
//                                 />
//                                 {searchQuery && (
//                                     <button type="button" onClick={clearSearch} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
//                                         <FiX size={20} />
//                                     </button>
//                                 )}
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </div>

//             <div className="container mx-auto px-4 py-4">
//                 {/* Mobile Filters & Sort Bar */}
//                 <div className="lg:hidden flex items-center justify-between mb-4 bg-white rounded-xl shadow-sm p-3">
//                     <div className="flex items-center gap-2">
//                         <button onClick={() => setShowMobileFilters(!showMobileFilters)} className="flex items-center gap-2 text-gray-700 text-sm font-medium">
//                             <FiFilter />
//                             Filters
//                             {showMobileFilters ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
//                         </button>
//                         {filteredProducts.length > 0 && (
//                             <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded-full">{filteredProducts.length}</span>
//                         )}
//                     </div>

//                     <div className="relative">
//                         <button onClick={() => setShowSortOptions(!showSortOptions)} className="flex items-center gap-2 text-gray-700 text-sm font-medium">
//                             Sort
//                             {showSortOptions ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
//                         </button>
//                         <AnimatePresence>
//                             {showSortOptions && (
//                                 <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
//                                     className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-lg border py-2 z-50 min-w-48">
//                                     {[
//                                         { value: "relevance",  label: "Relevance" },
//                                         { value: "price-low",  label: "Price: Low to High" },
//                                         { value: "price-high", label: "Price: High to Low" },
//                                         { value: "rating",     label: "Customer Rating" },
//                                         { value: "discount",   label: "Discount %" }
//                                     ].map((option) => (
//                                         <button key={option.value}
//                                             onClick={() => { setSortBy(option.value); setShowSortOptions(false); }}
//                                             className={`w-full px-4 py-2 text-left text-sm ${sortBy === option.value ? "bg-red-50 text-red-700 font-medium" : "text-gray-700 hover:bg-gray-100"}`}>
//                                             {option.label}
//                                         </button>
//                                     ))}
//                                 </motion.div>
//                             )}
//                         </AnimatePresence>
//                     </div>
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
//                     {/* Filters Sidebar */}
//                     {(showMobileFilters || window.innerWidth >= 1024) && (
//                         <div className="lg:col-span-1">
//                             <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:sticky lg:top-24">
//                                 <div className="flex items-center justify-between mb-6">
//                                     <h3 className="font-bold text-gray-900 flex items-center gap-2"><FiFilter /> Filters</h3>
//                                     <button onClick={resetFilters} className="text-sm text-red-600 hover:text-red-700 font-medium">Reset All</button>
//                                 </div>

//                                 {/* Price Range */}
//                                 <div className="mb-6">
//                                     <h4 className="font-medium text-gray-900 mb-3">Price Range</h4>
//                                     <div className="space-y-2">
//                                         <div className="flex items-center justify-between">
//                                             <span className="text-sm text-gray-600">Min: ₹{priceRange[0]}</span>
//                                             <span className="text-sm text-gray-600">Max: ₹{priceRange[1]}</span>
//                                         </div>
//                                         <input type="range" min="0" max="5000" step="100" value={priceRange[1]}
//                                             onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value)])}
//                                             className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-red-600" />
//                                         <div className="flex justify-between text-xs text-gray-500">
//                                             <span>₹0</span><span>₹2500</span><span>₹5000</span>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* ✅ Categories - ab proper names aayenge */}
//                                 <div className="mb-6">
//                                     <h4 className="font-medium text-gray-900 mb-3">Categories</h4>
//                                     <div className="space-y-2 max-h-60 overflow-y-auto">
//                                         <label className="flex items-center gap-2 cursor-pointer">
//                                             <input type="radio" name="category" value="all"
//                                                 checked={categoryFilter === "all"}
//                                                 onChange={(e) => setCategoryFilter(e.target.value)}
//                                                 className="w-4 h-4 text-red-600" />
//                                             <span className="text-sm text-gray-700">All Categories</span>
//                                         </label>
//                                         {categories.map((categoryName) => (
//                                             <label key={categoryName} className="flex items-center gap-2 cursor-pointer">
//                                                 <input type="radio" name="category" value={categoryName}
//                                                     checked={categoryFilter === categoryName}
//                                                     onChange={(e) => setCategoryFilter(e.target.value)}
//                                                     className="w-4 h-4 text-red-600" />
//                                                 <span className="text-sm text-gray-700">{categoryName}</span>
//                                             </label>
//                                         ))}
//                                     </div>
//                                 </div>

//                                 {/* Sort By */}
//                                 <div>
//                                     <h4 className="font-medium text-gray-900 mb-3">Sort By</h4>
//                                     <div className="space-y-2">
//                                         {[
//                                             { value: "relevance",  label: "Relevance" },
//                                             { value: "price-low",  label: "Price: Low to High" },
//                                             { value: "price-high", label: "Price: High to Low" },
//                                             { value: "rating",     label: "Customer Rating" },
//                                             { value: "discount",   label: "Discount %" }
//                                         ].map((option) => (
//                                             <label key={option.value} className="flex items-center gap-2 cursor-pointer">
//                                                 <input type="radio" name="sort" value={option.value}
//                                                     checked={sortBy === option.value}
//                                                     onChange={(e) => setSortBy(e.target.value)}
//                                                     className="w-4 h-4 text-red-600" />
//                                                 <span className="text-sm text-gray-700">{option.label}</span>
//                                             </label>
//                                         ))}
//                                     </div>
//                                 </div>

//                                 <div className="lg:hidden mt-6">
//                                     <button onClick={() => setShowMobileFilters(false)} className="w-full py-3 bg-red-600 text-white font-medium rounded-lg">
//                                         Apply Filters
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     {/* Search Results */}
//                     <div className="lg:col-span-3">
//                         <div className="flex items-center justify-between mb-6">
//                             <div>
//                                 <h2 className="text-lg font-bold text-gray-900">
//                                     {searchQuery ? `Search results for "${searchQuery}"` : "Search for products"}
//                                 </h2>
//                                 <p className="text-sm text-gray-600">
//                                     {searchQuery ? `${filteredProducts.length} products found` : "Type to search"}
//                                 </p>
//                             </div>
//                             {searchQuery && (
//                                 <div className="text-sm text-gray-600 hidden lg:block">
//                                     Showing {filteredProducts.length} of {products.length} products
//                                 </div>
//                             )}
//                         </div>

//                         {loading && (
//                             <div className="flex flex-col items-center justify-center h-64">
//                                 <div className="w-12 h-12 border-4 border-red-200 border-t-red-600 rounded-full animate-spin mb-4"></div>
//                                 <p className="text-gray-600">Searching products...</p>
//                             </div>
//                         )}

//                         {!loading && searchQuery && filteredProducts.length === 0 && (
//                             <div className="text-center py-12 bg-white rounded-2xl">
//                                 <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
//                                     <FiSearch className="text-gray-400 text-2xl" />
//                                 </div>
//                                 <h3 className="text-lg font-bold text-gray-900 mb-2">No results found</h3>
//                                 <p className="text-gray-600 mb-6">We couldn't find any products matching "{searchQuery}"</p>
//                                 <div className="flex flex-col sm:flex-row gap-3 justify-center">
//                                     <button onClick={clearSearch} className="px-6 py-2 border-2 border-red-600 text-red-600 rounded-full font-medium">Clear Search</button>
//                                     <button onClick={() => navigate("/products")} className="px-6 py-2 bg-red-600 text-white rounded-full font-medium">Browse All Products</button>
//                                 </div>
//                             </div>
//                         )}

//                         {!loading && filteredProducts.length > 0 && (
//                             <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4">
//                                 <AnimatePresence>
//                                     {filteredProducts.map((product) => (
//                                         <ProductCard
//                                             key={product.id}
//                                             product={product}
//                                             onAddToCart={handleAddToCart}
//                                             onToggleWishlist={toggleWishlist}
//                                             onQuantityUpdate={handleQuantityUpdate}
//                                             isWishlisted={wishlist[product.id] || wishlist[product._id] || false}
//                                             cartQuantity={cartQuantities[product.id] || 0}
//                                             navigate={navigate}
//                                             viewMode="grid"
//                                         />
//                                     ))}
//                                 </AnimatePresence>
//                             </div>
//                         )}

//                         {!searchQuery && !loading && (
//                             <div className="bg-white rounded-2xl p-6">
//                                 <h3 className="font-bold text-gray-900 mb-4">Popular Searches</h3>
//                                 <div className="flex flex-wrap gap-2">
//                                     {["Protein Powder", "Vitamins", "Ayurvedic", "Weight Loss", "Energy Drinks", "Hair Care", "Skin Care"].map((term) => (
//                                         <button key={term}
//                                             onClick={() => { setSearchQuery(term); navigate(`/search?q=${encodeURIComponent(term)}`); }}
//                                             className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full text-sm font-medium">
//                                             {term}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
    FiSearch,
    FiX,
    FiFilter,
    FiChevronUp,
    FiChevronDown
} from "react-icons/fi";
import { useCart } from "../App";
import ProductCard from "./ProductCard";

const PRODUCTS_API    = "https://server.havbit.in/api/public/products";
const CATEGORIES_API  = "https://server.havbit.in/api/categories"; // ✅ Same as Products.jsx

// ✅ Helper: create URL-friendly slug from product name
const createSlug = (name) => {
    if (!name) return '';
    return name
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/(^-|-$)/g, '');
};

const cleanApiSlug = (slug) => {
    if (!slug) return '';
    return slug.replace(/-\d{10,}$/, '');
};

const getProductSlug = (product) => {
    if (product.slug) return cleanApiSlug(product.slug);
    return createSlug(product.name);
};

export default function SearchPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { cart, addToCart, updateQty, removeFromCart } = useCart();

    const searchParams = new URLSearchParams(location.search);
    const initialQuery = searchParams.get('q') || '';

    const [searchQuery, setSearchQuery]         = useState(initialQuery);
    const [products, setProducts]               = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading]                 = useState(false);
    const [wishlist, setWishlist]               = useState({});
    const [sortBy, setSortBy]                   = useState("relevance");
    const [priceRange, setPriceRange]           = useState([0, 5000]);
    const [categoryFilter, setCategoryFilter]   = useState("all");
    const [categories, setCategories]           = useState([]); // ✅ stores category NAMES
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const [showSortOptions, setShowSortOptions] = useState(false);

    const searchInputRef = useRef(null);

    useEffect(() => {
        searchInputRef.current?.focus();
    }, []);

    const cartQuantities = cart.reduce((acc, item) => {
        acc[item._id] = item.qty || 1;
        return acc;
    }, {});

    useEffect(() => { fetchProducts(); }, []);

    useEffect(() => {
        const queryFromUrl = new URLSearchParams(location.search).get('q') || '';
        setSearchQuery(queryFromUrl);
    }, [location.search]);

    useEffect(() => {
        if (searchQuery && products.length > 0) {
            performSearch(products);
        } else if (!searchQuery) {
            setFilteredProducts([]);
        }
    }, [searchQuery, products, sortBy, priceRange, categoryFilter]);

    const fetchProducts = async () => {
        try {
            setLoading(true);

            // ✅ FIX: Fetch products AND categories simultaneously — same as Products.jsx
            const [productsRes, categoriesRes] = await Promise.all([
                fetch(PRODUCTS_API),
                fetch(CATEGORIES_API)
            ]);

            if (!productsRes.ok) throw new Error("Failed to fetch products");

            const productsResult  = await productsRes.json();
            const categoriesData  = categoriesRes.ok ? await categoriesRes.json() : [];

            // ✅ FIX: Build ID → Name map from categories API (same as Products.jsx)
            const categoriesMap = {};
            categoriesData.forEach(cat => {
                if (cat._id && cat.name) categoriesMap[cat._id] = cat.name;
            });

            // ✅ Handle both data.data and data.products response shapes
            const productsArray = productsResult.data || productsResult.products || productsResult || [];

            // ✅ FIX: Resolve category name using the map (same logic as Products.jsx)
            const formattedProducts = productsArray.map(product => {
                let categoryName = "";

                if (product.category && categoriesMap[product.category]) {
                    // category is an ID string → look up name in map
                    categoryName = categoriesMap[product.category];
                } else if (product.category && typeof product.category === 'object' && product.category.name) {
                    // category is already an object with name
                    categoryName = product.category.name;
                } else if (typeof product.category === 'string' && product.category.length < 40) {
                    // category is already a readable name (not a mongo ID)
                    categoryName = product.category;
                } else if (product.categoryName) {
                    categoryName = product.categoryName;
                }

                return {
                    ...product,
                    id: product._id || product.id,
                    slug: getProductSlug(product),
                    name: product.name || "Product",
                    price: product.price || product.newPrice || 0,
                    originalPrice: product.oldPrice || (product.price * 1.2) || 0,
                    image: product.image || "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400",
                    // ✅ category is now always a clean NAME string
                    category: categoryName || "General",
                    rating: parseFloat((Math.random() * 1.5 + 3.5).toFixed(1)),
                    reviewCount: Math.floor(Math.random() * 1000) + 50,
                    stock: product.stock || Math.floor(Math.random() * 50) + 10,
                    weight: product.itemWeight || product.customWeight || product.size || product.weight || "100g",
                    deliveryTime: `${Math.floor(Math.random() * 20) + 10} mins`,
                    discount: product.discount || Math.floor(Math.random() * 40) + 5
                };
            });

            // ✅ Extract unique category names from formatted products
            const uniqueCategories = [...new Set(
                formattedProducts
                    .map(p => p.category)
                    .filter(c => c && c !== "General")
            )].sort();

            setCategories(uniqueCategories);
            setProducts(formattedProducts);

            // ✅ Products load hone ke baad agar query hai toh fresh data pe search karo
            if (initialQuery) {
                performSearch(formattedProducts);
            }

            setLoading(false);
        } catch (error) {
            console.error("Error fetching products:", error);
            setLoading(false);
        }
    };

    const performSearch = (productsList = products) => {
        const query = searchQuery.toLowerCase().trim();
        if (!query) return;

        let results = productsList.filter(product => {
            // ✅ Exact: sirf product.name ke har word se match karo
            const nameLower = product.name.toLowerCase();
            const matchesSearch = nameLower.includes(query);

            const matchesPrice =
                product.price >= priceRange[0] && product.price <= priceRange[1];
            const matchesCategory =
                categoryFilter === "all" ||
                product.category.toLowerCase() === categoryFilter.toLowerCase();

            return matchesSearch && matchesPrice && matchesCategory;
        });

        results.sort((a, b) => {
            switch (sortBy) {
                case "price-low":  return a.price - b.price;
                case "price-high": return b.price - a.price;
                case "rating":     return b.rating - a.rating;
                case "discount":   return b.discount - a.discount;
                default:
                    const aScore = a.name.toLowerCase().includes(searchQuery.toLowerCase()) ? 2 : 1;
                    const bScore = b.name.toLowerCase().includes(searchQuery.toLowerCase()) ? 2 : 1;
                    return bScore - aScore;
            }
        });

        setFilteredProducts(results);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
            performSearch();
        }
    };

    const handleSearchChange = (value) => {
        setSearchQuery(value);
        navigate(value.trim()
            ? `/search?q=${encodeURIComponent(value.trim())}`
            : "/", { replace: true });
    };

    const clearSearch = () => {
        setSearchQuery("");
        setFilteredProducts([]);
        navigate("/");
    };

    const handleAddToCart = (product, quantity = 1) => {
        addToCart({
            _id: product.id,
            name: product.name,
            price: product.price,
            originalPrice: product.originalPrice,
            image: product.image,
            category: product.category,
            weight: product.weight,
            qty: quantity
        }, quantity);
    };

    const handleQuantityUpdate = (productId, change) => {
        const currentQty = cartQuantities[productId] || 0;
        const newQty = currentQty + change;
        if (newQty < 1) removeFromCart(productId);
        else updateQty(productId, newQty);
    };

    const toggleWishlist = (product) => {
        const productId = product._id || product.id;
        setWishlist(prev => ({ ...prev, [productId]: !prev[productId] }));
    };

    const resetFilters = () => {
        setSortBy("relevance");
        setPriceRange([0, 5000]);
        setCategoryFilter("all");
    };

    return (
        <div className="min-h-screen bg-gray-50 pb-24">

            {/* Mobile search header */}
            <div className="lg:hidden bg-white sticky top-0 z-30 border-b shadow-sm">
                <div className="container mx-auto px-4 py-3">
                    <form onSubmit={handleSearch} className="relative">
                        <div className="flex items-center gap-2">
                            <button type="button" onClick={() => navigate(-1)} className="text-gray-600 hover:text-red-600 flex-shrink-0">←</button>
                            <div className="flex-1 relative">
                                <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                                <input
                                    ref={searchInputRef}
                                    type="text"
                                    value={searchQuery}
                                    onChange={(e) => handleSearchChange(e.target.value)}
                                    placeholder="Search for products, brands, categories..."
                                    className="w-full pl-12 pr-12 py-3 bg-gray-100 border-none rounded-xl focus:ring-2 focus:ring-red-500 focus:bg-white"
                                />
                                {searchQuery && (
                                    <button type="button" onClick={clearSearch} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                                        <FiX size={20} />
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div className="container mx-auto px-4 py-4">
                {/* Mobile Filters & Sort Bar */}
                <div className="lg:hidden flex items-center justify-between mb-4 bg-white rounded-xl shadow-sm p-3">
                    <div className="flex items-center gap-2">
                        <button onClick={() => setShowMobileFilters(!showMobileFilters)} className="flex items-center gap-2 text-gray-700 text-sm font-medium">
                            <FiFilter />
                            Filters
                            {showMobileFilters ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
                        </button>
                        {filteredProducts.length > 0 && (
                            <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded-full">{filteredProducts.length}</span>
                        )}
                    </div>

                    <div className="relative">
                        <button onClick={() => setShowSortOptions(!showSortOptions)} className="flex items-center gap-2 text-gray-700 text-sm font-medium">
                            Sort
                            {showSortOptions ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
                        </button>
                        <AnimatePresence>
                            {showSortOptions && (
                                <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
                                    className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-lg border py-2 z-50 min-w-48">
                                    {[
                                        { value: "relevance",  label: "Relevance" },
                                        { value: "price-low",  label: "Price: Low to High" },
                                        { value: "price-high", label: "Price: High to Low" },
                                        { value: "rating",     label: "Customer Rating" },
                                        { value: "discount",   label: "Discount %" }
                                    ].map((option) => (
                                        <button key={option.value}
                                            onClick={() => { setSortBy(option.value); setShowSortOptions(false); }}
                                            className={`w-full px-4 py-2 text-left text-sm ${sortBy === option.value ? "bg-red-50 text-red-700 font-medium" : "text-gray-700 hover:bg-gray-100"}`}>
                                            {option.label}
                                        </button>
                                    ))}
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                    {/* Filters Sidebar */}
                    {(showMobileFilters || window.innerWidth >= 1024) && (
                        <div className="lg:col-span-1">
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:sticky lg:top-24">
                                <div className="flex items-center justify-between mb-6">
                                    <h3 className="font-bold text-gray-900 flex items-center gap-2"><FiFilter /> Filters</h3>
                                    <button onClick={resetFilters} className="text-sm text-red-600 hover:text-red-700 font-medium">Reset All</button>
                                </div>

                                {/* Price Range */}
                                <div className="mb-6">
                                    <h4 className="font-medium text-gray-900 mb-3">Price Range</h4>
                                    <div className="space-y-2">
                                        <div className="flex items-center justify-between">
                                            <span className="text-sm text-gray-600">Min: ₹{priceRange[0]}</span>
                                            <span className="text-sm text-gray-600">Max: ₹{priceRange[1]}</span>
                                        </div>
                                        <input type="range" min="0" max="5000" step="100" value={priceRange[1]}
                                            onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value)])}
                                            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-red-600" />
                                        <div className="flex justify-between text-xs text-gray-500">
                                            <span>₹0</span><span>₹2500</span><span>₹5000</span>
                                        </div>
                                    </div>
                                </div>

                                {/* ✅ Categories - ab proper names aayenge */}
                                <div className="mb-6">
                                    <h4 className="font-medium text-gray-900 mb-3">Categories</h4>
                                    <div className="space-y-2 max-h-60 overflow-y-auto">
                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input type="radio" name="category" value="all"
                                                checked={categoryFilter === "all"}
                                                onChange={(e) => setCategoryFilter(e.target.value)}
                                                className="w-4 h-4 text-red-600" />
                                            <span className="text-sm text-gray-700">All Categories</span>
                                        </label>
                                        {categories.map((categoryName) => (
                                            <label key={categoryName} className="flex items-center gap-2 cursor-pointer">
                                                <input type="radio" name="category" value={categoryName}
                                                    checked={categoryFilter === categoryName}
                                                    onChange={(e) => setCategoryFilter(e.target.value)}
                                                    className="w-4 h-4 text-red-600" />
                                                <span className="text-sm text-gray-700">{categoryName}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                {/* Sort By */}
                                <div>
                                    <h4 className="font-medium text-gray-900 mb-3">Sort By</h4>
                                    <div className="space-y-2">
                                        {[
                                            { value: "relevance",  label: "Relevance" },
                                            { value: "price-low",  label: "Price: Low to High" },
                                            { value: "price-high", label: "Price: High to Low" },
                                            { value: "rating",     label: "Customer Rating" },
                                            { value: "discount",   label: "Discount %" }
                                        ].map((option) => (
                                            <label key={option.value} className="flex items-center gap-2 cursor-pointer">
                                                <input type="radio" name="sort" value={option.value}
                                                    checked={sortBy === option.value}
                                                    onChange={(e) => setSortBy(e.target.value)}
                                                    className="w-4 h-4 text-red-600" />
                                                <span className="text-sm text-gray-700">{option.label}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                <div className="lg:hidden mt-6">
                                    <button onClick={() => setShowMobileFilters(false)} className="w-full py-3 bg-red-600 text-white font-medium rounded-lg">
                                        Apply Filters
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Search Results */}
                    <div className="lg:col-span-3">
                        <div className="flex items-center justify-between mb-6">
                            <div>
                                <h2 className="text-lg font-bold text-gray-900">
                                    {searchQuery ? `Search results for "${searchQuery}"` : "Search for products"}
                                </h2>
                                <p className="text-sm text-gray-600">
                                    {searchQuery ? `${filteredProducts.length} products found` : "Type to search"}
                                </p>
                            </div>
                            {searchQuery && (
                                <div className="text-sm text-gray-600 hidden lg:block">
                                    Showing {filteredProducts.length} of {products.length} products
                                </div>
                            )}
                        </div>

                        {loading && (
                            <div className="flex flex-col items-center justify-center h-64">
                                <div className="w-12 h-12 border-4 border-red-200 border-t-red-600 rounded-full animate-spin mb-4"></div>
                                <p className="text-gray-600">Searching products...</p>
                            </div>
                        )}

                        {!loading && searchQuery && filteredProducts.length === 0 && (
                            <div className="text-center py-12 bg-white rounded-2xl">
                                <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
                                    <FiSearch className="text-gray-400 text-2xl" />
                                </div>
                                <h3 className="text-lg font-bold text-gray-900 mb-2">No results found</h3>
                                <p className="text-gray-600 mb-6">We couldn't find any products matching "{searchQuery}"</p>
                                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                                    <button onClick={clearSearch} className="px-6 py-2 border-2 border-red-600 text-red-600 rounded-full font-medium">Clear Search</button>
                                    <button onClick={() => navigate("/products")} className="px-6 py-2 bg-red-600 text-white rounded-full font-medium">Browse All Products</button>
                                </div>
                            </div>
                        )}

                        {!loading && filteredProducts.length > 0 && (
                            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4">
                                <AnimatePresence>
                                    {filteredProducts.map((product) => (
                                        <ProductCard
                                            key={product.id}
                                            product={product}
                                            onAddToCart={handleAddToCart}
                                            onToggleWishlist={toggleWishlist}
                                            onQuantityUpdate={handleQuantityUpdate}
                                            isWishlisted={wishlist[product.id] || wishlist[product._id] || false}
                                            cartQuantity={cartQuantities[product.id] || 0}
                                            navigate={navigate}
                                            viewMode="grid"
                                        />
                                    ))}
                                </AnimatePresence>
                            </div>
                        )}

                        {!searchQuery && !loading && (
                            <div className="bg-white rounded-2xl p-6">
                                <h3 className="font-bold text-gray-900 mb-4">Popular Searches</h3>
                                <div className="flex flex-wrap gap-2">
                                    {["Protein Powder", "Vitamins", "Ayurvedic", "Weight Loss", "Energy Drinks", "Hair Care", "Skin Care"].map((term) => (
                                        <button key={term}
                                            onClick={() => { setSearchQuery(term); navigate(`/search?q=${encodeURIComponent(term)}`); }}
                                            className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full text-sm font-medium">
                                            {term}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}